import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
    UilabMatButton,
    UilabMatFormFieldModule,
    UilabMatInputModule,
} from '@uilab/ng-mat-components';
import { CssVariableSnippetComponent } from '../../../../shared/components/css-variable-snippet/css-variable-snippet.component';
import { StylingCardShellComponent } from '../styling-card-shell/styling-card-shell.component';

@Component({
    selector: 'avd-elevated-container-color-card',
    standalone: true,
    templateUrl: './elevated-container-color-card.component.html',
    styleUrls: ['./elevated-container-color-card.component.scss'],
    imports: [
        UilabMatButton,
        StylingCardShellComponent,
        UilabMatFormFieldModule,
        UilabMatInputModule,
        CssVariableSnippetComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElevatedContainerColorCardComponent {
    @Input() cssVariable: string = '';
    @Input() boxShadowCssVariable: string = '';
    @Input() label: string = '';
    @Input() inverseMode: boolean = false;

    get cssVariableName(): string {
        return this.cssVariable.trim();
    }

    get boxShadowCssVariableName(): string {
        return this.boxShadowCssVariable.trim();
    }

    get containerColorVariableSnippet(): string {
        return this.cssVariableName;
    }

    get boxShadowVariableSnippet(): string {
        return this.boxShadowCssVariableName;
    }
}
